import * as pages from './pages.json';
import * as text from './text.json';
import * as ui from './ui.json';
export const translation = { pages, text, ui };
